import { cn } from '@/lib/cn'

/**
 * Aspecto común de los controles de formulario: inputs, áreas, selects y el
 * selector de fecha.
 *
 * El texto mide 16 px en celular: por debajo de eso, Safari en iPhone amplía
 * la pantalla al tocar el campo y rompe la vista (error que reportó Serena el
 * 22/09). En escritorio sigue en 14 px.
 */
export const CONTROL = cn(
  'w-full rounded-xl border border-borde bg-tarjeta px-3.5 py-2.5 text-base text-tinta sm:text-sm',
  'placeholder:text-tinta-suave/70',
  'focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-tinta',
  'disabled:bg-lienzo disabled:text-tinta-suave',
  'aria-[invalid=true]:border-nuevo',
)
